
import React from 'react';
import { useInView, slideUpAnimation } from '../utils/animations';
import { useIsMobile } from '../hooks/use-mobile';

const AboutUs = () => {
  const [sectionRef, isInView] = useInView({ threshold: 0.1 });
  const isMobile = useIsMobile();

  return (
    <section id="about" className="section bg-white">
      <div 
        className={`container-custom ${slideUpAnimation(isInView)}`} 
        ref={sectionRef}
      >
        {isMobile ? (
          <div className="flex flex-col items-center">
            <h3 className="font-serif text-2xl text-navy-900 mb-5 text-center">Poznaj nas</h3>
            <div className="relative mb-6">
              <div className="aspect-square rounded-2xl overflow-hidden max-w-[300px]">
                <img 
                  src="/lovable-uploads/2ea5f71b-5685-4596-b21d-6965304a242d.png" 
                  alt="Czułe Klisze - zespół fotografów" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="text-center max-w-md mx-auto px-6">
              <p className="text-elegant-600 text-sm mb-3 text-center">
                Cenimy autentyczność bardziej niż perfekcję. To prawdziwe emocje, spojrzenia i gesty tworzą opowieść, którą chcemy dla Was zatrzymać — nie tylko w tych wielkich momentach, ale też w drobnych, często niezauważalnych.
              </p>
              <p className="text-elegant-600 text-sm mb-3 text-center">
                Po ponad 60 reportażach wiemy, kiedy po prostu obserwować, a kiedy pomóc lub podpowiedzieć — zwłaszcza podczas sesji.
              </p>
              <p className="text-elegant-600 text-sm mb-3 text-center">
                W dniu ślubu szukamy emocji, bliskości i nostalgii. Inspirują nas stare fotografie i kino. Kluczowe są dla nas światło i kolor — to na nich budujemy klimat zdjęć i filmu.
              </p>
              <p className="text-elegant-600 text-sm text-center">
                Każdy reportaż traktujemy serio. To dla nas więcej niż praca — to historia, którą chcemy opowiedzieć tak, by cieszyła Was przez lata.
              </p>
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="max-w-lg mx-auto px-8">
              <h3 className="font-serif text-3xl md:text-4xl text-navy-900 mb-5">Poznaj nas</h3>
              <p className="text-elegant-600 mb-4 text-center">
                Cenimy autentyczność bardziej niż perfekcję. To prawdziwe emocje, spojrzenia i gesty tworzą opowieść, którą chcemy dla Was zatrzymać — nie tylko w tych wielkich momentach, ale też w drobnych, często niezauważalnych.
              </p>
              <p className="text-elegant-600 mb-4 text-center">
                Po ponad 60 reportażach wiemy, kiedy po prostu obserwować, a kiedy pomóc lub podpowiedzieć — zwłaszcza podczas sesji.
              </p>
              <p className="text-elegant-600 mb-4 text-center">
                W dniu ślubu szukamy emocji, bliskości i nostalgii. Inspirują nas stare fotografie i kino. Kluczowe są dla nas światło i kolor — to na nich budujemy klimat zdjęć i filmu.
              </p>
              <p className="text-elegant-600 text-center">
                Każdy reportaż traktujemy serio. To dla nas więcej niż praca — to historia, którą chcemy opowiedzieć tak,by cieszyła Was przez lata.
              </p>
            </div>
            <div className="relative">
              <div className="aspect-square rounded-2xl overflow-hidden">
                <img 
                  src="/lovable-uploads/2ea5f71b-5685-4596-b21d-6965304a242d.png" 
                  alt="Czułe Klisze - zespół fotografów" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default AboutUs;
